<template>
    <a-cascader
        v-if="isAllSelect"
        v-model="cascadeValue"
        :options="options"
        :fieldNames="fieldNames"
        :placeholder="parameters.placeholder"
        expandTrigger="hover"
        :allowClear="parameters.clearable"
        @change="onChangeCascade"/>
<!--    showSearch-->
    <a-tree-select
        v-else
        :class="{'show-placeholder': !treeSelectValue}"
        v-model="treeSelectValue"
        :treeData="options"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :placeholder="parameters.placeholder"
        :replaceFields="replaceFields"
        :allowClear="parameters.clearable"
        treeDefaultExpandAll
        @change="onChangeTreeSelect"/>
</template>

<script>
    export default {
        name: 'SdCascade',
        components: {},
        props: {
            value: {
                type: [String, Number],
                required: true
            },
            field: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                cascadeValue: [],
                treeSelectValue: undefined,
                fieldNames: {
                    value: 'value',
                    label: 'label',
                    children: 'children'
                },
                replaceFields: {
                    key: 'value',
                    value: 'value',
                    label: 'label',
                    children: 'children'
                }
            }
        },
        computed: {
            // data-entry组件参数
            parameters() {
                return this.field.commonProperties
                    ? JSON.parse(this.field.commonProperties).options
                    : {}
            },
            // 是否全选所有层级
            isAllSelect() {
                return this.parameters.isAllSelect
            },
            // 选项
            options() {
                const options = []
                this.parameters.options.forEach(item => {
                    if (item.isEnable) {
                        item.children = this.getOptions(item.children)
                        options.push(item)
                    }
                })
                return options
            }
        },
        created() {
            this.setValue()
        },
        methods: {
            setValue() {
                if (this.value) {
                    try {
                        const arr = JSON.parse(this.value)
                        if (this.isAllSelect) {
                            const cascadeValue = []
                            arr.forEach(item => {
                                cascadeValue.push(item.value)
                            })
                            this.cascadeValue = cascadeValue
                        }
                        else {
                            this.treeSelectValue = arr[arr.length - 1].value || undefined
                        }
                    }
                    catch (e) {
                        console.error(e)
                        if (this.parameters.defaultValue) {
                            try {
                                const arr = JSON.parse(this.parameters.defaultValue)
                                if (this.isAllSelect) {
                                    const cascadeValue = []
                                    arr.forEach(item => {
                                        cascadeValue.push(item.value)
                                    })
                                    this.cascadeValue = cascadeValue
                                    this.$emit('update:value', this.parameters.defaultValue)
                                }
                                else {
                                    this.treeSelectValue = arr[arr.length - 1].value || undefined
                                    this.$emit('update:value', this.parameters.defaultValue)
                                }
                            }
                            catch (e) {
                                console.error(e)
                            }
                        }
                        else {
                            if (this.isAllSelect) {
                                this.cascadeValue = []
                            }
                            else {
                                this.treeSelectValue = undefined
                            }
                            this.$emit('update:value', '')
                        }
                    }
                }
                else {
                    if (this.parameters.defaultValue) {
                        try {
                            const arr = JSON.parse(this.parameters.defaultValue)
                            if (this.isAllSelect) {
                                const cascadeValue = []
                                arr.forEach(item => {
                                    cascadeValue.push(item.value)
                                })
                                this.cascadeValue = cascadeValue
                                this.$emit('update:value', this.parameters.defaultValue)
                            }
                            else {
                                if(arr.length===0) this.treeSelectValue = ""
                                else this.treeSelectValue = arr[arr.length - 1].value || undefined
                                this.$emit('update:value', this.parameters.defaultValue)
                            }
                        }
                        catch (e) {
                            console.error(e)
                        }
                    }
                    else {
                        if (this.isAllSelect) {
                            this.cascadeValue = []
                        }
                        else {
                            this.treeSelectValue = undefined
                        }
                    }
                }
            },
            // 级联（必选全部层级）
            onChangeCascade(values) {
                let arr = []
                let options = JSON.parse(JSON.stringify(this.options))
                values.forEach(item => {
                    const result = this.getOptionCodeAndChildren(item, options)
                    if (result.option) {
                        arr.push(result.option)
                        options = result.options
                    }
                })
                this.$emit('update:value', JSON.stringify(arr))
            },
            // 树形选择
            onChangeTreeSelect(value) {
                const values = this.treeFindPath(this.options, item => item.value === value)
                let arr = []
                let options = JSON.parse(JSON.stringify(this.options))
                values.forEach(item => {
                    const result = this.getOptionCodeAndChildren(item, options)
                    if (result.option) {
                        arr.push(result.option)
                        options = result.options
                    }
                })
                this.$emit('update:value', JSON.stringify(arr))
            },
            getOptions(options) {
                const children = []
                options.forEach(item => {
                    if (item.isEnable) {
                        item.children = this.getOptions(item.children)
                        children.push(item)
                    }
                })
                return children
            },
            getOptionCodeAndChildren(value, options) {
                const result = {
                    option: '',
                    options: []
                }
                for (let i = 0; i < options.length; i++) {
                    if (options[i].value === value) {
                        result.option = {
                            value: options[i].value,
                            label: options[i].label,
                            level: options[i].level
                        }
                        result.options = options[i].children
                        break
                    }
                }
                return result
            },
            treeFindPath(tree, func, path = []) {
                if (!tree) return []
                for (const data of tree) {
                    path.push(data.value)
                    if (func(data)) return path
                    if (data.children) {
                        const findChildren = this.treeFindPath(data.children, func, path)
                        if (findChildren.length) return findChildren
                    }
                    path.pop()
                }
                return []
            }
        }
    }
</script>

<style scoped lang="less">
    .show-placeholder {
        .ant-select-selection__placeholder {
            display: inline-block!important;
        }
    }
</style>
